/**
 * Created by seven on 2018/4/26.
 */

export default {
  name: 'en',
  messages: {
    alpha: () => 'Some English Message',
    email: () => 'Email format error!!!!!',
    required: (value) => value + ' required!!'
  }
}
